import styled from "styled-components";

const Main = styled.main`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

    @media (max-width: 768px) {
        height: auto;
    }
`

export default Main